import apiClient from "./apiClient"
import { UnknownRecord } from "../models/api"

export async function createSale(
    companyId: string,
    payload: UnknownRecord
): Promise<UnknownRecord> {
    return apiClient.post(`/api/companies/${companyId}/sales`, payload)
}

export async function getSale(
    companyId: string,
    saleId: string
): Promise<UnknownRecord> {
    return apiClient.get(`/api/companies/${companyId}/sales/${saleId}`)
}

export async function addSaleLine(
    companyId: string,
    saleId: string,
    payload: UnknownRecord
): Promise<UnknownRecord> {
    return apiClient.post(
        `/api/companies/${companyId}/sales/${saleId}/items`,
        payload
    )
}

export async function updateSaleCustomer(
    companyId: string,
    saleId: string,
    customerId: string | null
): Promise<UnknownRecord> {
    return apiClient.patch(
        `/api/companies/${companyId}/sales/${saleId}/customer`,
        {
            customerId,
        }
    )
}

export async function removeSaleLine(
    companyId: string,
    saleId: string,
    lineId: string
): Promise<UnknownRecord> {
    return apiClient.delete(
        `/api/companies/${companyId}/sales/${saleId}/items/${lineId}`
    )
}

export async function updateSaleLineQuantity(
    companyId: string,
    saleId: string,
    lineId: string,
    quantity: number
): Promise<UnknownRecord> {
    return apiClient.patch(
        `/api/companies/${companyId}/sales/${saleId}/items/${lineId}`,
        { quantity }
    )
}

export async function applyLineDiscount(
    companyId: string,
    saleId: string,
    lineId: string,
    discountType: string,
    discountValue: number
): Promise<UnknownRecord> {
    return apiClient.post(
        `/api/companies/${companyId}/sales/${saleId}/items/${lineId}/discount`,
        { discountType, discountValue }
    )
}

export async function applyGlobalDiscount(
    companyId: string,
    saleId: string,
    discountType: string,
    discountValue: number
): Promise<UnknownRecord> {
    return apiClient.post(
        `/api/companies/${companyId}/sales/${saleId}/discount`,
        { discountType, discountValue }
    )
}

export async function updateSaleComment(
    companyId: string,
    saleId: string,
    comment: string
): Promise<UnknownRecord> {
    return apiClient.patch(
        `/api/companies/${companyId}/sales/${saleId}/comment`,
        { comment }
    )
}

export async function updateSaleStatus(
    companyId: string,
    saleId: string,
    status: string
): Promise<UnknownRecord> {
    return apiClient.patch(
        `/api/companies/${companyId}/sales/${saleId}/status`,
        {
            status,
        }
    )
}

export async function listSales(
    companyId: string,
    registerId: string,
    status: string,
    search = ""
): Promise<UnknownRecord> {
    return apiClient.get(
        `/api/companies/${companyId}/sales?registerId=${registerId}&status=${status}&search=${encodeURIComponent(
            search
        )}`
    )
}

export async function countSales(
    companyId: string,
    registerId: string,
    status: string
): Promise<UnknownRecord> {
    return apiClient.get(
        `/api/companies/${companyId}/sales-count?registerId=${registerId}&status=${status}`
    )
}

export async function cancelSale(
    companyId: string,
    saleId: string
): Promise<UnknownRecord> {
    return apiClient.delete(`/api/companies/${companyId}/sales/${saleId}`)
}

export async function finalizeSale(
    companyId: string,
    saleId: string
): Promise<UnknownRecord> {
    return apiClient.post(
        `/api/companies/${companyId}/sales/${saleId}/finalize`,
        {}
    )
}

export async function totalizeSale(
    companyId: string,
    saleId: string
): Promise<UnknownRecord> {
    return apiClient.post(
        `/api/companies/${companyId}/sales/${saleId}/totalize`,
        {}
    )
}

const salesService = {
    createSale,
    getSale,
    addSaleLine,
    removeSaleLine,
    updateSaleLineQuantity,
    applyLineDiscount,
    applyGlobalDiscount,
    updateSaleComment,
    updateSaleStatus,
    updateSaleCustomer,
    listSales,
    countSales,
    cancelSale,
    finalizeSale,
    totalizeSale,
}

export default salesService
